import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  data: {},
  loading: false,
  fetchedUpdateTelemetry: false,
  fetchingUpdateTelemetry: false,
};

const telemetryReducer = createReducer(initialState)({
  [types.FETCH_TELEMETRY_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedUpdateTelemetry: false,
    };
  },
  [types.FETCH_TELEMETRY_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      data: payload,
      loading: false,
    };
  },
  [types.FETCH_TELEMETRY_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.FETCH_UPDATE_TELEMETRY_REQUEST]: (state) => {
    return {
      ...state,
      fetchedUpdateTelemetry: false,
      fetchingUpdateTelemetry: true,
    };
  },
  [types.FETCH_UPDATE_TELEMETRY_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetchedUpdateTelemetry: true,
      fetchingUpdateTelemetry: false,
    };
  },
  [types.FETCH_UPDATE_TELEMETRY_FAILED]: (state) => {
    return {
      ...state,
      fetchedUpdateTelemetry: false,
      fetchingUpdateTelemetry: false,
    };
  },
  [types.FETCH_RESET_UPDATE_TELEMETRY_FAILED]: (state) => {
    return {
      ...state,
      fetchedUpdateTelemetry: false,
    };
  },
});

export default telemetryReducer;
